import React,{useState} from 'react';
import {Table, Figure} from 'react-bootstrap'
import {FaSort, FaUser,FaHistory, FaBox, FaImage} from 'react-icons/fa';
import { BiCabinet } from "react-icons/bi";
import Pagination from "react-js-pagination";
import {RSpinner} from '@putil-view/item.r-spinner';
import PropTypes from "prop-types";
import "css/r-table.css";
import {GiJigsawBox} from 'react-icons/gi';
import { FiScissors } from "react-icons/fi";
import { GoLocation } from "react-icons/go";
import { ImBin } from "react-icons/im";
import {SysPath} from 'SysContext';
import {RModal} from '@putil-view/item.r-modal';
import {RDownload} from '@putil-view/item.r-download';
import {useScreen} from '@putil-view/use.use-screen';

const TableHeader  = ({handleSort}) =>{
  return (
      <thead key="thead" className='bg-custom-green r-table-header'>
        <tr key="theadtr">
          <td key='text' name="Text" onClick={handleSort}><FaSort/><span>ID</span></td>
          <td key='creator' name="creator" onClick={handleSort}><FaSort/><span>Creator</span></td>
          <td key='images' className="no-sort" name="Text"><FaSort/><span>Files</span></td>
          <td key='create_time' name="Create time" onClick={handleSort}><FaSort/><span>DateTime</span></td>
          <td key='cutPadlock' name="Cut Padlock" onClick={handleSort}><FaSort/><span>Cut Padlock</span></td>
          <td key='itemsFound' name="Items Found" onClick={handleSort}><FaSort/><span>Items Found</span></td>
          <td key='reserved' name="Reserved" onClick={handleSort}><FaSort/><span>Reserved</span></td>
          <td key='location' name="Location" onClick={handleSort}><FaSort/><span>Location</span></td>
          <td key='disposed' name="Disposed" onClick={handleSort}><FaSort/><span>Disposed</span></td>
        </tr>
      </thead>
    );
}
TableHeader.propTypes = {
  handleSort: PropTypes.func,
};
const TableBody = ({rows}) => {
  return (
      <tbody className="r-table-body">
        {
          rows.map(
            (obj, index) =>  {var className='';
            if(index < 2){
              if((index+1 < rows.length && rows[index+1]['Text'].indexOf(obj['Text']) !== -1)){
                className='match-area-top match-area-left match-area-right';
              }
               if(index - 1 >= 0 && rows[index-1]['Text'].indexOf(obj['Text']) !== -1){
                className='match-area-bottom match-area-left match-area-right';
              }
            }
            return <TableRow className={className} key={'table_row_'+(obj.ID ? obj.ID :index)} obj={obj} />
            })
          }
      </tbody>
    );
}
TableBody.propTypes = {
  rows: PropTypes.array
}

const TableRow = (props)=> {
  const screen = useScreen();
  const [showModal, setShowModal] = useState(false)
  const className = props.className;
  const obj = props.obj;
  const text = obj['Text'].replace(/\\/g,'/');
  const creator = obj['Creator'];
  const createTime = new Date(obj['Create Time']).toLocaleString().replace('下午','PM\n').replace('上午','AM\n').replace(',','');
  const cutPadlock = obj['Cut Padlock'];
  const itemsFound = obj['Items Found'];
  const reserved = obj['Reserved'];
  const location = obj['Location'];
  const disposed = obj['Disposed'];
  const getImgByPathUrl = SysPath.getImgByPathUrl;
  const getVideoByPathUrl = SysPath.getVideoByPathUrl;
  const previewFileStyle = {
    height: screen.isWideScreen ?'50vh':'45vh',
    width:  screen.isWideScreen ?'50vh':'100%',
    display:'flex',
    justifyContent: 'center',
    objectFit: 'cover'
  };
  return(
    <>
    <tr className={className}>
      <td><BiCabinet/><span>{text}</span></td>
      <td><FaUser/><span>{creator}</span></td>
      <td onClick={()=>{setShowModal(true)}} >
        <div className="link-button"><FaImage/><span className="link-button">View</span></div>
      </td>
      <td><FaHistory/><span>{createTime}</span></td>
      <td><FiScissors/><span>{cutPadlock}</span></td>
      <td><GiJigsawBox/><span>{itemsFound}</span></td>
      <td><FaBox/><span>{reserved.split(';').map((item)=>{return <>{item}<br/></>})}</span></td>
      <td><GoLocation/><span>{location}</span></td>
      <td><ImBin/><span>{disposed.split(';').map((item)=>{return <>{item}<br/></>})}</span></td>
    </tr>
    <RModal show={showModal} title= {text + " Clear Record Files"} handleModalClose={()=>{setShowModal(false)}}>
      <>
      <br/>
      {['Locker Apperance Image', 'Locker Items Image', 'Locker Items Cleared Image'].map(prop => {
        return (
          <>
          <Figure>
            <RDownload fileName={prop+".png"} url={getImgByPathUrl+'?path='+obj[prop]}>
            <Figure.Image 
                style={previewFileStyle}
                src={getImgByPathUrl+'?path='+obj[prop]}
              />
            </RDownload>
          </Figure>
          <br/>
          </>
        )
      })}
      {obj['Locker Video'] && 
        <Figure>
        <div className="d-flex justify-content-center ">
        <video style={previewFileStyle} controls>
          <source src={getVideoByPathUrl+'?path='+obj['Locker Video']}/>
        </video>
        </div>
        <RDownload fileName={"Locker Video"} url={getVideoByPathUrl+'?path='+obj['Locker Video']}/>
        </Figure>
      }
      </>
    </RModal>
    </>
  )




}
TableRow.propTypes = {
  className:PropTypes.string,
  obj: PropTypes.object,
  index: PropTypes.number
};


export const ClearTable = ({config,datas,handleSort, handlePaginationNum}) =>{
  const pages = parseInt(datas.count/config.limit) + 1;
  return (
    <>
      {config.spinner
        ?
          <RSpinner style={{height:'25vh'}}/>
        :
          <>
            <Table>
              <TableHeader handleSort={handleSort}/>
              <TableBody  rows={datas.rows}/>
            </Table>
            <Pagination
              activePage={config.paginationNum}
              itemsCountPerPage={config.limit}
              totalItemsCount={datas.count}
              pageRangeDisplayed={ pages < 7  ? pages : 7}
              innerClass="pagination justify-content-center mb-0"
              itemClass="page-item"
              linkClass="page-link"
              onChange={(number) => handlePaginationNum(number)}
            />
          </>
      }
    </>
  );
}
ClearTable.propTypes = {
  config:PropTypes.object,
  datas: PropTypes.object,
  handlePaginationNum: PropTypes.func,
  handleSort: PropTypes.func
};
